import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrivateBasketComponent } from '../../index/private-basket/private-basket.component';
import { PropertyMassUpdateComponent } from '../property-mass-update/property-mass-update.component';
import { takeUntil } from 'rxjs/operators';
import { forEach } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { PropertiesService } from 'app/services/properties.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ExportXlsComponent } from 'app/components/export-xls/export-xls.component';
import { PropertiesPrintEmailComponent } from '../../properties-print-email/properties-print-email.component';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { AccountsService } from 'app/services/accounts.service';
import { RejectAccountComponent } from '../../index/reject-account/reject-account.component';
import { ImportConfirmModalComponent } from 'app/components/import-confirm-modal/import-confirm-modal.component';
import { PropertiesAddToPortalComponent } from '../properties-add-to-portal/properties-add-to-portal.component';
import { GlobalFuntions } from 'app/_helpers';
import { AuthenticationService } from 'app/services';
import { AttachmentExportDialogComponent } from 'app/components/attachment-export-dialog/attachment-export-dialog.component';

@Component({
  selector: 'app-index-menu-button',
  templateUrl: './index-menu-button.component.html',
  styleUrls: ['./index-menu-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IndexMenuButtonComponent implements OnInit {

  @Input() selectedItems = [];
  @Input() selectedReferences = [];
  @Input() selectedMls = [];
  @Input() account: any;
  @Input() rejection: any;
  @Input() interested: any;
  @Output() delSelected: EventEmitter<any>;
  @Output() reloadProperties: EventEmitter<any>;
  updateDialogRef: any;
  confirmDialogRef: any;
  currentAgency: any;
  currentUser: any;
  private _unsubscribeAll = new Subject<string>();
  slectedProperties: any;
  searchDialogRef: MatDialogRef<ImportConfirmModalComponent, any>;

  constructor(
    private _matDialog: MatDialog,
    private _propertiesService: PropertiesService,
    private _translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private _accountsService: AccountsService,
    private _globalFunction: GlobalFuntions,
    private _authenticationService: AuthenticationService,

  ) {
    this.delSelected = new EventEmitter();
    this.reloadProperties = new EventEmitter();
    this.currentAgency = this._authenticationService.currentAgencyValue;
    this.currentUser = this._authenticationService.currentUserValue;
  }

  ngOnInit(): void {
  }

  exportXLS(): void {
    this._matDialog.open(ExportXlsComponent, {
      panelClass: 'export-form-dialog',
      disableClose: false,
      data: {
        ids: this.selectedItems,
        schema: 'properties'
      }
    });
  }

  uploadConfirm(upload: any): void {
    upload.value = null
    const dialog = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });
    dialog.componentInstance.confirmMessage = this._translateService.instant('Are you sure you want to import Properties?');
    dialog.afterClosed().subscribe(result => {
      if (result) {
        upload.click();
      }
    });
  }

  privateBasket(): void {
    this._matDialog.open(PrivateBasketComponent, {
      panelClass: 'event-form-dialog',
      disableClose: false
    });
  }

  add(): void {
    this.router.navigateByUrl('/properties/create');
  }

  massUpdate(): void {
    this.updateDialogRef = this._matDialog.open(PropertyMassUpdateComponent, {
      panelClass: 'mass-dialog',
      data: { properties: this.selectedItems, isMls: this.selectedMls.length ? true : false }
    });
    this.updateDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          const ids = [];
          forEach(this.selectedItems, (value, key) => {
            ids.push(value);
          });
          const data = { properties: ids, form_data: response };
          this._propertiesService.bulkUpdate(data).subscribe(() => {
            this._snackBar.open(this._translateService.instant('Your properties will be updated with in 20 min'), this._translateService.instant('Close'), {
              duration: 4000,
            });
          });
        }
      });
  }

  addToInterested(): void {
    if ((this.account.properties_interested)) {
      forEach(this.selectedReferences, (value, key) => {
        if (value && this.account.properties_interested.indexOf(value) === -1) {
          this.account.properties_interested.push(value);
        }
      });
    } else {
      this.account.properties_interested = this.selectedReferences;
    }
    this._accountsService.update(this.account).subscribe(() => {
      this._snackBar.open(this._translateService.instant('Added as Interested Properties'), this._translateService.instant('Close'), {
        duration: 4000,
      });
    });
  }
  removeFromInterested(): void {
    forEach(this.selectedReferences, (value, key) => {
      if (this.account.properties_interested.indexOf(value) > -1) {
        const index = this.account.properties_interested.indexOf(value);
        this.account.properties_interested.splice(index, 1);
      }
    });
    this._accountsService.update(this.account).subscribe(() => {
      this._snackBar.open(this._translateService.instant('Interested Properties removed'), this._translateService.instant('Close'), {
        duration: 4000,
      });
      this.reloadProperties.next(true);
    });
  }

  navigate(): void {
    this._matDialog.open(PropertiesPrintEmailComponent, {
      panelClass: 'pdf-dialog',
      data: {
        selectedItems: this.selectedItems,
        account: this.account
      },
      disableClose: true
    });

    // this.router.navigate(['/properties/print-pdf'], { state: { data: this.selectedItems, account: this.account } });
  }

  rejectProperties(): void {
    const dialog = this._matDialog.open(RejectAccountComponent, {
      disableClose: true
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
        const excludeFilter = {
          account: this.account,
          commercial: false,
          message: result,
          property: this.selectedItems
        };
        this._accountsService.excludeProperties(excludeFilter)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((data: any) => {
            this.reloadProperties.next(true);
          });
      }
    });
  }

  onSelectCsv(files: FileList): void {
    this._propertiesService.uploadCsv(files[0])
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        this.searchDialogRef = this._matDialog.open(ImportConfirmModalComponent, {
          panelClass: 'event-form-dialog',
          disableClose: false,
          data: {
            data: data
          }
        });
        this.searchDialogRef.afterClosed()
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((response: any) => {
            if (response) {
              this._snackBar.open(this._translateService.instant('Import successfully'), this._translateService.instant('Close'), {
                duration: 2000,
              });
              this.reloadProperties.next(true);
            }
          });
      });
  }

  deleteProperties(): void {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });
    this.confirmDialogRef.componentInstance.confirmMessage = this._translateService.instant('Are you sure you want to delete?');
    this.confirmDialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe((result: any) => {
      if (result) {
        this.delSelected.next(this.selectedItems);
      }
    });
  }

  addtoPortal(): any {
    this._matDialog.open(PropertiesAddToPortalComponent, {
      panelClass: 'event-form-dialog',
      disableClose: false,
      data: {
        model: 'properties',
        propertyIds: this.selectedItems
      }
    });
  }

  exportAttachments() {
    const dialog = this._matDialog.open(AttachmentExportDialogComponent, {
      disableClose: false,
    });
    dialog.afterClosed().subscribe(result => {
      if (result && (result.images || result.documents)) {
        // this.loadingResults = true;
        const data = {
          props: this.selectedItems,
          image: result.images,
          document: result.documents,
        }
        this._propertiesService.exportAttachments(data)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((res) => {
            var element = document.createElement('a');
            var blob = new Blob([res], {
              type: 'text/xml'
            });
            var url = URL.createObjectURL(blob);
            element.href = url;
            element.setAttribute('download', 'Attachments.xml');
            document.body.appendChild(element);
            element.click();
          });
      }
    });
  }

}
